<section [ngClass]="dynamicClass">
  <div class="eq-container eq-flex eq-flex-col lg:eq-flex-row">
    <div class="xl:eq-w-1/2 eq-mb-6 lg:eq-mb-0">
      <div class="eq-text-center lg:eq-text-start eq-mt-6">
        <h2 class="eq-mb-6 eq-font-bold eq-text-blue-darkBlue eq-text-heading2-m lg:eq-text-heading2" *scText="rendering.fields.Title"></h2>
        <div class="eq-mb-6 eq-text-black-natural-60 eq-text-body-m lg:eq-text-body" *scText="rendering.fields.Subtitle"></div>
        <a *ngIf="rendering?.fields?.Link?.value?.href" class="eq-btn eq-btn-secondary eq-w-full lg:eq-w-fit" hybridHref href="{{rendering?.fields?.Link?.value?.href}}" attr.aria-label="{{rendering?.fields?.Link?.value?.text}}">{{rendering?.fields?.Link?.value?.text}}</a>
      </div>
    </div>
    <div class="xl:eq-w-1/2">
      <ng-container *ngFor="let item of rendering?.fields?.ListRightItems">
        <app-list-right-item [data]="item"></app-list-right-item>
      </ng-container>
    </div>
  </div>
</section>